/* icon/UI 24px/Person Single (user, individual, member, account).svg: width 24px x height 24px */
export default class DlsIconPersonSingle extends HTMLElement {
  static define(tagName = 'dls-icon-person-single') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M16.5 5.75a4.5 4.5 0 11-9 0 4.5 4.5 0 119 0z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M2.25 23.291v-.393l.828-5.346a5.67 5.67 0 015.603-4.802h6.416a5.668 5.668 0 015.601 4.802l.828 5.346v.393"/></svg>`;
  }
}
DlsIconPersonSingle.define();
